import MultiStoresSelect from './MultiStoresSelect'

export default MultiStoresSelect
